export default {
  // DASHBOARD
  SELECTED_KEY_UPDATE: 'SELECTED_KEY_UPDATE',
  SELECTED_KEY_CLEAR: 'SELECTED_KEY_CLEAR',
  OPEN_KEYS_ADD: 'OPEN_KEYS_ADD',
  OPEN_KEYS_UPDATE: 'OPEN_KEYS_UPDATE',
  OPEN_KEYS_CLEAR: 'OPEN_KEYS_CLEAR'
};